import { categories, mainSiteUrl } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

const articleLinks = [
  { label: 'Complete Beginner Guide', slug: '/allchinabuy-spreadsheet-guide' },
  { label: 'Best Shoes 2026', slug: '/allchinabuy-best-shoes-spreadsheet-2026' },
  { label: 'Trusted Sellers List', slug: '/allchinabuy-trusted-sellers-list' },
  { label: 'Clothing Spreadsheet Guide', slug: '/allchinabuy-clothing-spreadsheet-guide' },
  { label: 'QC Photos Guide', slug: '/allchinabuy-qc-photos-guide' },
  { label: 'Yupoo Connections', slug: '/allchinabuy-yupoo-spreadsheet-guide' },
  { label: 'Bags Spreadsheet Guide', slug: '/allchinabuy-bags-spreadsheet-guide' },
  { label: 'Shipping Tips', slug: '/allchinabuy-shipping-tips-guide' },
  { label: 'Free Daily Finds', slug: '/free-allchinabuy-finds-daily' },
  { label: 'vs Alternatives', slug: '/allchinabuy-spreadsheet-vs-alternatives' },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">
              AllChinaBuy<span className="text-primary-500">Spreadsheet</span>
            </h3>
            <p className="text-foreground-300 text-xs leading-relaxed mb-4">
              The largest free AllChinaBuy Spreadsheet for discovering trusted products, verified seller links, QC photos, and daily updated finds across 14 categories.
            </p>
            <p className="text-foreground-400 text-xs">
              © 2026 AllChinaBuySpreadsheet.asia
            </p>
          </div>

          <div>
            <h4 className="text-foreground-300 text-xs font-semibold uppercase tracking-widest mb-4">Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-300 hover:text-white text-xs transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-300 text-xs font-semibold uppercase tracking-widest mb-4">More Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-300 hover:text-white text-xs transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-300 text-xs font-semibold uppercase tracking-widest mb-4">Guides & Resources</h4>
            <div className="flex flex-col gap-2">
              {articleLinks.map((link) => (
                <button
                  key={link.slug}
                  onClick={() => { navigate(link.slug); window.scrollTo(0, 0); }}
                  className="text-foreground-300 hover:text-white text-xs transition-colors text-left whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 text-center">
          <div className="text-foreground-300 text-xs mb-3">
            AllChinaBuySpreadsheet.asia is an independent information resource. We are not affiliated with AllChinaBuy.
          </div>
          <div className="flex items-center justify-center gap-6">
            <button onClick={() => { navigate('/'); window.scrollTo(0, 0); }} className="text-foreground-400 hover:text-white text-xs transition-colors whitespace-nowrap cursor-pointer">
              Home
            </button>
            <button onClick={() => { navigate('/allchinabuy-spreadsheet-guide'); window.scrollTo(0, 0); }} className="text-foreground-400 hover:text-white text-xs transition-colors whitespace-nowrap cursor-pointer">
              Shopping Guide
            </button>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-xs transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-xs transition-colors whitespace-nowrap">
              Terms of Use
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white text-xs transition-colors whitespace-nowrap">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}